import { Link } from "react-router-dom";
import type { MovieItem } from "@/mocks/movies";

export default function MovieCard({ item }: { item: MovieItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      data-product-shop
      className="group block cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}（${item.year}） - 色即是空`}
          title={`${item.title} ${item.year}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 px-2 py-0.5 rounded bg-primary-950/70 text-background-50 text-xs whitespace-nowrap">
          {item.type === "movie" ? "电影" : "剧集"}
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded bg-accent-500/90 text-background-50 text-xs whitespace-nowrap">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating}
        </div>
      </div>
      <h3 className="mt-3 text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
        {item.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 whitespace-nowrap overflow-hidden text-ellipsis">
        {item.year} · {item.region} · {item.genre.join(" / ")}
      </p>
    </Link>
  );
}